<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-5"><a href="#/OEBPS/Away_With_the_Fairies2#Contents-A">Epigraph</a></p>
<p class="quote"><em class="italic">The strong subject, notwithstanding the efforts against him, survives and acquires fresh vigour. The people again cherish their sovereign, and the plotters have wrought their own overthrow.</em></p>
<p class="quote-by">Hexagram 23: Po<br class="calibre2"/><em class="italic">The I Ching Book of Changes</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Away_With_the_Fairies-4.vue?354d3fc5